export const dataMinimaRelatorios = "01/01/2018";

/* Dia da criação do micro serviço de animais */
export const dataMinimaRelatorioEspecifico = {
  CSV_HistoricoOperacoes: "08/17/2021",
};
